<template>
  <div>
    <template
        v-for="opts in options"
        :key="opts"
    >
      <BaseRadio
          :name="name"
          :label="opts"
          :is-required="isRequired"
          :modelValue="modelValue"
          :value="opts"
          @update:modelValue="$emit('update:modelValue', $event)"
      />
    </template>
  </div>
</template>

<script>
export default {
  props: {
    vertical: {
      type: Boolean,
      default: false
    },
    modelValue: {
      // type: [String, Number],
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: false
    },
    isRequired: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
